export default __webpack_public_path__ + "static/O0206-3e70e7de23dd047a81d941b7d9b0fba5.png";